export enum RelationNotificationDay {
  DayBefore = 0,
  DayOf = 1,
}

// Laden (inbound): "dag ervoor" is de vorige wérkdag van de organisatie (Zendesk 658). Zelfde enumwaarde als
// bij lossen, alleen het label verschilt; de backend bepaalt de verzenddatum.
export const RelationNotificationDayInboundOptions = [
  {
    label: "views.relation.relation_detail_view.cards.general.instructions.notifications.workday_before",
    value: RelationNotificationDay.DayBefore,
  },
  {
    label: "views.relation.relation_detail_view.cards.general.instructions.notifications.day_of",
    value: RelationNotificationDay.DayOf,
  },
];

// Lossen (outbound): "dag ervoor" blijft de vorige kalenderdag.
export const RelationNotificationDayOptions = [
  {
    label: "views.relation.relation_detail_view.cards.general.instructions.notifications.day_before",
    value: RelationNotificationDay.DayBefore,
  },
  {
    label: "views.relation.relation_detail_view.cards.general.instructions.notifications.day_of",
    value: RelationNotificationDay.DayOf,
  },
];
